import { useHistory } from 'react-router-dom';
import { routes } from '~/constants';
import { useStoreActions } from '~/contexts.ts';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
export const useCreateDraft = (param)=>{
    let { onSuccess } = param;
    const { api } = useStoreActions();
    const history = useHistory();
    const { mutate, isPending } = useMutationState({
        mutationFn: async (templateId)=>{
            return await api.proposalTemplates.createDraft(templateId);
        },
        onSuccess: (draftId)=>{
            history.push(routes.draft(draftId));
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        }
    });
    return {
        createDraft: mutate,
        isInProgress: isPending
    };
};
